import { render, staticRenderFns } from "./ChangePhone.vue?vue&type=template&id=e48990bc&scoped=true&"
import script from "./ChangePhone.vue?vue&type=script&lang=ts&"
export * from "./ChangePhone.vue?vue&type=script&lang=ts&"
import style0 from "./ChangePhone.vue?vue&type=style&index=0&id=e48990bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48990bc",
  null
  
)

export default component.exports